import _defineProperty from "D:\\a\\1\\s\\Immocom\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "D:\\a\\1\\s\\Immocom\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "D:\\a\\1\\s\\Immocom\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Immocom\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import 'moment/locale/fr';
import { saveAs } from 'file-saver';
var moment = require('moment');
var Scriba = /*#__PURE__*/function () {
  function Scriba() {
    _classCallCheck(this, Scriba);
  }
  _createClass(Scriba, null, [{
    key: "test",
    value: function test(objet) {
      console.log(objet);
    }
  }, {
    key: "fetch",
    value: function fetch() {
      return Scriba_fetch;
    }
  }, {
    key: "nombre",
    value: function nombre() {
      return Scriba_Nombre;
    }
  }, {
    key: "date",
    value: function date() {
      return Scriba_Date;
    }
  }, {
    key: "traduction",
    value: function traduction() {
      return Scriba_Traduction;
    }
  }, {
    key: "officeUI",
    value: function officeUI() {
      return Scriba_OfficeUI;
    }
  }, {
    key: "outils",
    value: function outils() {
      return Scriba_Outils;
    }
  }, {
    key: "chaine",
    value: function chaine() {
      return Scriba_Chaine;
    }
  }, {
    key: "fichier",
    value: function fichier() {
      return Scriba_Fichier;
    }
  }, {
    key: "state",
    value: function state() {
      return Scriba_State;
    }
  }, {
    key: "formulaire",
    value: function formulaire() {
      return Scriba_Formulaire;
    }
  }]);
  return Scriba;
}();
export { Scriba as default };
var Scriba_Formulaire = /*#__PURE__*/function () {
  function Scriba_Formulaire() {
    _classCallCheck(this, Scriba_Formulaire);
  }
  _createClass(Scriba_Formulaire, null, [{
    key: "nombreEstValide",
    //Scriba.formulaire()
    value: function nombreEstValide(nombreAVerifier, nePeutEtreNull, supporteNegatif, precision) {
      return Scriba.nombre().nombreEstValide(nombreAVerifier, nePeutEtreNull, supporteNegatif, precision);
    }
  }, {
    key: "nEstPasVide",
    value: function nEstPasVide(chaine) {
      return Scriba.chaine().nEstPasVide(chaine);
    }
  }]);
  return Scriba_Formulaire;
}();
var Scriba_fetch = /*#__PURE__*/function () {
  function Scriba_fetch() {
    _classCallCheck(this, Scriba_fetch);
  }
  _createClass(Scriba_fetch, null, [{
    key: "traitementRetour",
    //à modifier
    value: function traitementRetour(data, _this, codeLimiteErreur) {
      if (codeLimiteErreur === undefined) {
        codeLimiteErreur = 1000;
      }
      var CHAMPS_VERIF = {
        hideMessageBarWarning: true,
        hideMessageBarError: true,
        warningMessage: null,
        errorMessage: null
      };
      var hideMessageBarWarning = _this.state.hideMessageBarWarning;
      var warningMessage = _this.state.warningMessage;
      var hideMessageBarError = _this.state.hideMessageBarError;
      var errorMessage = _this.state.errorMessage;
      var retourVerif = CHAMPS_VERIF;
      if (data.codeRetour > 0 && data.codeRetour < codeLimiteErreur) {
        hideMessageBarWarning = false;
        warningMessage = data.messageInfo;
      } else if (data.codeRetour >= codeLimiteErreur) {
        hideMessageBarError = false;
        errorMessage = data.messageRetour;
      } else {
        hideMessageBarWarning = true;
        warningMessage = null;
        hideMessageBarError = true;
        errorMessage = null;
      }
      retourVerif.hideMessageBarWarning = hideMessageBarWarning === undefined ? true : hideMessageBarWarning;
      retourVerif.warningMessage = warningMessage === undefined ? null : warningMessage;
      retourVerif.hideMessageBarError = hideMessageBarError === undefined ? true : hideMessageBarError;
      retourVerif.errorMessage = errorMessage === undefined ? null : errorMessage;
      return retourVerif;
    }
  }, {
    key: "createParameterPost",
    value: function createParameterPost(objet) {
      var paramPost = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(objet)
      };
      return paramPost;
    }
  }]);
  return Scriba_fetch;
}();
var Scriba_Nombre = /*#__PURE__*/function () {
  function Scriba_Nombre() {
    _classCallCheck(this, Scriba_Nombre);
  }
  _createClass(Scriba_Nombre, null, [{
    key: "nombreEstValide",
    //Scriba.nombre()
    value: function nombreEstValide(nombreAVerifier, nePeutEtreNull, supporteNegatif, precision) {
      nePeutEtreNull = nePeutEtreNull || false;
      supporteNegatif = supporteNegatif || false;
      precision = precision || 0;
      var estValide = false;
      if (nombreAVerifier != null) {
        if (!Number.isNaN(Number(nombreAVerifier))) {
          estValide = true;
          var nombreValide = Number(nombreAVerifier);
          if (!supporteNegatif && nombreValide < 0) {
            estValide = false;
          }
          if (estValide) {
            var partieDecimal = nombreAVerifier.toString().split(".")[1];
            if (partieDecimal === undefined) partieDecimal = "";
            if (partieDecimal.length > precision) estValide = false;
          }
        }
      } else {
        if (!nePeutEtreNull) {
          estValide = true;
        }
      }
      return estValide;
    }
  }, {
    key: "nombreValide",
    value: function nombreValide(nombreAVerifier, remplaceVideParZero, supporteNegatif, precision) {
      remplaceVideParZero = remplaceVideParZero || false;
      supporteNegatif = supporteNegatif || false;
      precision = precision || 0;
      var nombre = null;
      if (nombreAVerifier == null || nombreAVerifier === '') {
        nombre = null;
      } else {
        if (Scriba.nombre().nombreEstValide(nombreAVerifier, true, supporteNegatif, precision)) {
          nombre = Number(nombreAVerifier);
        } else {
          nombre = null;
        }
      }
      if (remplaceVideParZero && nombre == null) nombre = 0;
      return nombre;
    }
  }, {
    key: "nombreVersTexte",
    //Formate un nombre pour un affichage humain (en mode texte) 
    value: function nombreVersTexte(nombreAFormater, supporteNegatif, precision, langage) {
      return Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(nombreAFormater, supporteNegatif, precision, precision, langage);
    } //Formate un nombre pour un affichage humain (en mode texte) - la précision/precisionAffichee permet d'avoir une validation d'un nombre avec plus de précision et contrôler le nobme de décimales présentées
  }, {
    key: "nombreVersTexteAvecPrecisionAfficheeSpecifiee",
    value: function nombreVersTexteAvecPrecisionAfficheeSpecifiee(nombreAFormater, supporteNegatif, precision, precisionAffichee, langage) {
      supporteNegatif = supporteNegatif || false;
      precision = precision || 0;
      precisionAffichee = precisionAffichee || precision;
      langage = langage || 'fr';
      var nombreFormate = '';
      if (nombreAFormater != null && nombreAFormater !== '') {
        if (Scriba.nombre().nombreEstValide(nombreAFormater, true, supporteNegatif, precision)) {
          nombreFormate = new Intl.NumberFormat(langage, {
            minimumFractionDigits: precisionAffichee,
            maximumFractionDigits: precisionAffichee
          }).format(nombreAFormater);
        } else {
          nombreFormate = nombreAFormater;
        }
      }
      return nombreFormate;
    }
  }, {
    key: "texteVersNombre",
    value: function texteVersNombre(texteAParser, langage) {
      langage = langage || 'fr';
      var nombre = '';
      if (texteAParser != null && texteAParser !== "") {
        nombre = texteAParser.toString();
        if (langage === 'fr') {
          nombre = nombre.replace(/ /g, "");
          nombre = nombre.replace(/ /g, ""); //Char special (non c'est pas le même ;p)
          nombre = nombre.replace(',', '.');
        } else if (langage === 'en') {
          nombre = nombre.replace(/,/g, "");
          nombre = nombre.replace(/,/g, ""); //Char special (non c'est pas le même ;p)
        }
      }
      return nombre;
    }
  }]);
  return Scriba_Nombre;
}();
var Scriba_Date = /*#__PURE__*/function () {
  function Scriba_Date() {
    _classCallCheck(this, Scriba_Date);
  }
  _createClass(Scriba_Date, null, [{
    key: "getChaineISOFromDate",
    value: function getChaineISOFromDate(dateAFormater, forceLocalVersUTC) {
      forceLocalVersUTC = forceLocalVersUTC || false;
      var dateExtraite = null;
      if (dateAFormater !== null && dateAFormater !== "" && dateAFormater !== undefined) {
        if (forceLocalVersUTC !== true) {
          dateExtraite = moment(dateAFormater).toISOString(true);
        } else {
          dateAFormater = Scriba.date().dateForceFormatUTC(dateAFormater);
          dateExtraite = dateAFormater.toISOString();
        }
      }
      return dateExtraite;
    }
  }, {
    key: "getDateFromChaineISO",
    value: function getDateFromChaineISO(chaineISO, forceUTCVersLocal) {
      forceUTCVersLocal = forceUTCVersLocal || false;
      var dateExtraite = null;
      if (chaineISO != null && chaineISO !== "" && chaineISO !== undefined) {
        dateExtraite = moment(chaineISO)._d;
        if (forceUTCVersLocal === true) {
          dateExtraite = Scriba.date().dateForceFormatGMTLocal(dateExtraite);
        }
      }
      return dateExtraite;
    }
  }, {
    key: "dateForceFormatUTC",
    value: function dateForceFormatUTC(dateGMTLocale) {
      if (dateGMTLocale != null && dateGMTLocale !== undefined && dateGMTLocale !== '') {
        var dateUTC = new Date(dateGMTLocale.getTime() - dateGMTLocale.getTimezoneOffset() * 60000);
        return dateUTC;
      } else return null;
    }
  }, {
    key: "dateForceFormatGMTLocal",
    value: function dateForceFormatGMTLocal(dateUTC) {
      if (dateUTC != null && dateUTC !== undefined && dateUTC !== '') {
        var dateGMTLocale = new Date(dateUTC.getTime() + dateUTC.getTimezoneOffset() * 60000);
        return dateGMTLocale;
      } else return null;
    }
  }, {
    key: "dateExtraireChaineDateCourte",
    value: function dateExtraireChaineDateCourte(dateCourte, language) {
      language = language || 'fr';
      moment.locale(language);
      var dateExtraite = null;
      dateExtraite = moment(dateCourte, 'L', language).toDate();
      return dateExtraite;
    }
  }, {
    key: "stringDateFormatCourt",
    value: function stringDateFormatCourt(dateAFormater, langage) {
      return Scriba.date().stringDateFormat(dateAFormater, 'L', langage);
    }
  }, {
    key: "stringDateFormatLong",
    value: function stringDateFormatLong(dateAFormater, langage) {
      return Scriba.date().stringDateFormat(dateAFormater, 'LL', langage);
    }
  }, {
    key: "stringDateHeureFormatCourt",
    value: function stringDateHeureFormatCourt(dateAFormater, langage) {
      return Scriba.date().stringDateFormat(dateAFormater, 'lll', langage);
    }
  }, {
    key: "stringDateFormat",
    /**
    * Retourne une date en chaine selon le format passé en paramètre
    * @param {Date} dateAFormater - Date à formater
    * @param {string} formatDate - Format de la date
    * Formats disponibles :
    * LT => 11:08
    * LTS => 11:08:58
    * L => 15/04/2019
    * l => 15/4/2019
    * LL => 15 avril 2019
    * ll => 15 avr. 2019
    * LLL => 15 avril 2019 11:08
    * lll => 15 avr. 2019 11:08
    * LLLL => lundi 15 avril 2019 11:08
    * llll => lun. 15 avr. 2019 11:08
    * @param {string} [langage=fr] - Langue de traduction (facultatif)
    */
    value: function stringDateFormat(dateAFormater, formatDate, langage) {
      var dateFomatee = '';
      if (dateAFormater != null) {
        langage = langage || 'fr';
        moment.locale(langage);
        dateFomatee = moment(dateAFormater).format(formatDate);
      }
      return dateFomatee;
    }
  }, {
    key: "getDateAujourdhui",
    value: function getDateAujourdhui(forceUTC) {
      var dateMaintenant = new Date();
      var dateAujourdhui = new Date(dateMaintenant.getFullYear(), dateMaintenant.getMonth(), dateMaintenant.getDay());
      if (forceUTC === true) {
        dateAujourdhui = Scriba.date().dateForceFormatUTC(dateAujourdhui);
      }
      return dateAujourdhui;
    }
  }, {
    key: "getRelativeTime",
    value: function getRelativeTime(dateReference, langage) {
      langage = langage || 'fr';
      moment.locale(langage);
      var dateHeureFormatCourt = Scriba.date().stringDateHeureFormatCourt(dateReference, langage);
      return moment(dateHeureFormatCourt, "lll").fromNow();
    }
  }]);
  return Scriba_Date;
}();
var Scriba_Traduction = /*#__PURE__*/function () {
  function Scriba_Traduction() {
    _classCallCheck(this, Scriba_Traduction);
  }
  _createClass(Scriba_Traduction, null, [{
    key: "stringsTermes",
    value: function stringsTermes() {
      var stringsTermesScriba = {
        fr: {
          LangueEnCours: 'Français',
          Francais: 'Français',
          Anglais: 'Anglais',
          DayPickerStrings: {
            months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            shortMonths: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            shortDays: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            Valider: "Valider",
            goToToday: 'Aller à aujourd\'hui',
            prevMonthAriaLabel: 'Aller au mois précédent',
            nextMonthAriaLabel: 'Aller au mois suivant',
            prevYearAriaLabel: 'Aller à l\'année précédente',
            nextYearAriaLabel: 'Aller à l\'année suivante',
            closeButtonAriaLabel: 'Fermer le date picker',
            isRequiredErrorMessage: 'La date est obligatoire',
            invalidInputErrorMessage: 'Format de date invalide'
          },
          SelectionDate: 'Selectionnez une date'
        },
        en: {
          LangueEnCours: 'English',
          Francais: 'French',
          Anglais: 'English',
          DayPickerStrings: {
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            shortMonths: ['Jan', 'Fev', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            Valider: "Validate",
            goToToday: 'Go to today',
            prevMonthAriaLabel: 'Go to previous month',
            nextMonthAriaLabel: 'Go to next month',
            prevYearAriaLabel: 'Go to previous year',
            nextYearAriaLabel: 'Go to next year',
            closeButtonAriaLabel: 'Close date picker',
            isRequiredErrorMessage: 'Date required.',
            invalidInputErrorMessage: 'Invalid date format.'
          },
          SelectionDate: "Select a date"
        }
      };
      return stringsTermesScriba;
    }
  }]);
  return Scriba_Traduction;
}();
var Scriba_OfficeUI = /*#__PURE__*/function () {
  function Scriba_OfficeUI() {
    _classCallCheck(this, Scriba_OfficeUI);
  }
  _createClass(Scriba_OfficeUI, null, [{
    key: "textField",
    value: function textField() {
      return Scriba_OfficeUITextField;
    }
  }, {
    key: "datePicker",
    value: function datePicker() {
      return Scriba_OfficeUIDatePicker;
    }
  }, {
    key: "comboBox",
    value: function comboBox() {
      return Scriba_OfficeUIComboBox;
    }
  }]);
  return Scriba_OfficeUI;
}();
var Scriba_OfficeUITextField = /*#__PURE__*/function () {
  function Scriba_OfficeUITextField() {
    _classCallCheck(this, Scriba_OfficeUITextField);
  }
  _createClass(Scriba_OfficeUITextField, null, [{
    key: "nombre",
    value: function nombre() {
      return Scriba_OfficeUITextFieldNombre;
    }
  }, {
    key: "texte",
    value: function texte() {
      return Scriba_OfficeUITextFieldText;
    }
  }]);
  return Scriba_OfficeUITextField;
}();
var Scriba_OfficeUITextFieldNombre = /*#__PURE__*/function () {
  function Scriba_OfficeUITextFieldNombre() {
    _classCallCheck(this, Scriba_OfficeUITextFieldNombre);
  }
  _createClass(Scriba_OfficeUITextFieldNombre, null, [{
    key: "ValeurChampNombre",
    value: function ValeurChampNombre(_this, nomValeurState, supporteNegatif, precision, langage) {
      return Scriba.officeUI().textField().nombre().ValeurChampNombreAvecPrecisionAfficheeSpecifiee(_this, nomValeurState, supporteNegatif, precision, precision, langage);
    }
  }, {
    key: "ValeurChampNombreAvecPrecisionAfficheeSpecifiee",
    value: function ValeurChampNombreAvecPrecisionAfficheeSpecifiee(_this, nomValeurState, supporteNegatif, precision, precisionAffichee, langage) {
      supporteNegatif = supporteNegatif || false;
      precision = precision || 0;
      precisionAffichee = precisionAffichee || precision;
      langage = langage || 'fr';
      var nombreDuState = _this.state[nomValeurState];
      var nombre = null;
      var ALeFocus = false;
      if (_this.state[nomValeurState + 'AFocus'] === true) {
        ALeFocus = true;
      }
      if (ALeFocus) {
        nombre = nombreDuState;
      } else {
        nombre = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(nombreDuState, supporteNegatif, precision, precisionAffichee, langage);
      }
      return nombre;
    }
  }, {
    key: "ValeurChampNombreObjet",
    value: function ValeurChampNombreObjet(_this, nomObjet, nomPropriete, supporteNegatif, precision, langage) {
      return Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(_this, nomObjet, nomPropriete, supporteNegatif, precision, precision, langage);
    }
  }, {
    key: "ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee",
    value: function ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(_this, nomObjet, nomPropriete, supporteNegatif, precision, precisionAffichee, langage) {
      supporteNegatif = supporteNegatif || false;
      precision = precision || 0;
      precisionAffichee = precisionAffichee || precision;
      langage = langage || 'fr';
      var nombreDeObjetPropriete = _this.state[nomObjet][nomPropriete];
      //let objet = { ..._this.state[nomObjet] };
      //var nombreDeObjetPropriete = objet[nomPropriete];

      var nombre = null;
      var ALeFocus = false;
      if (_this.state[nomObjet + '_' + nomPropriete + 'AFocus'] === true) {
        ALeFocus = true;
      }
      if (ALeFocus) {
        nombre = nombreDeObjetPropriete;
      } else {
        nombre = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(nombreDeObjetPropriete, supporteNegatif, precision, precisionAffichee, langage);
      }
      return nombre;
    }
  }, {
    key: "onFocusTextFieldNombre",
    value: function onFocusTextFieldNombre(_this, nomValeur, callBack) {
      var objChampAFocus = {};
      objChampAFocus[nomValeur + 'AFocus'] = true;
      if (callBack != undefined) _this.setState(objChampAFocus, callBack);else _this.setState(objChampAFocus);
    }
  }, {
    key: "onFocusTextFieldNombreObjet",
    value: function onFocusTextFieldNombreObjet(_this, nomObjet, nomValeur, callBack) {
      var objChampAFocus = {};
      objChampAFocus[nomObjet + '_' + nomValeur + 'AFocus'] = true;
      if (callBack != undefined) _this.setState(objChampAFocus, callBack);else _this.setState(objChampAFocus);
    }
  }, {
    key: "onBlurTextFieldNombre",
    value: function onBlurTextFieldNombre(_this, nomValeurState, valeur, langage, callBack) {
      langage = langage || 'fr';
      var objChampAFocus = {};
      objChampAFocus[nomValeurState + 'AFocus'] = false;
      _this.setState(objChampAFocus);
      var nombre = valeur;
      nombre = nombre.replace(/ /g, "");
      nombre = nombre.replace(/ /g, ""); //Char special (non c'est pas le même ;p)

      if (langage === 'fr') {
        nombre = nombre.replace(',', '.');
      }
      if (nombre === "") nombre = null;
      var obj = {};
      obj[nomValeurState] = nombre;
      if (callBack != undefined) _this.setState(obj, callBack);else _this.setState(obj);
    }
  }, {
    key: "onBlurTextFieldNombreObjet",
    value: function onBlurTextFieldNombreObjet(_this, nomObjet, nomPropriete, valeur, langage, callBack) {
      langage = langage || 'fr';
      var objChampAFocus = {};
      objChampAFocus[nomObjet + '_' + nomPropriete + 'AFocus'] = false;
      _this.setState(objChampAFocus);
      var nombre = valeur;
      nombre = nombre.replace(/ /g, "");
      nombre = nombre.replace(/ /g, ""); //Char special (non c'est pas le même ;p)

      if (langage === 'fr') {
        nombre = nombre.replace(',', '.');
      }
      if (nombre === "") nombre = null;
      Scriba.state().setObjetPropriete(_this, nomObjet, nomPropriete, nombre, callBack); //valeur);
    }
  }, {
    key: "onGetErrorMessageTextFieldNombre",
    value: function onGetErrorMessageTextFieldNombre(_this, nomValeurState, valeur, supporteNegatif, precision, langage) {
      var messageErreur = '';
      var aLeFocus = false;
      if (_this !== null && nomValeurState != null) {
        if (_this.state[nomValeurState + 'AFocus'] === true) {
          aLeFocus = true;
        }
      }
      if (valeur != null && valeur !== '') {
        langage = langage || 'fr';
        precision = precision || 0;
        supporteNegatif = supporteNegatif || false;
        if (!aLeFocus) {
          valeur = Scriba.nombre().texteVersNombre(valeur, langage);
        }
        if (precision === 0) {
          messageErreur = Scriba.officeUI().textField().nombre().controleNombreEntier(valeur, supporteNegatif, langage);
        } else {
          messageErreur = Scriba.officeUI().textField().nombre().controleNombreDecimal(valeur, supporteNegatif, precision, langage);
        }
      }
      return messageErreur;
    }
  }, {
    key: "controleNombreEntier",
    value: function controleNombreEntier(valeur, supporteNegatif, langage) {
      langage = langage || 'fr';
      supporteNegatif = supporteNegatif || false;
      var message = '';
      var messageErreur = '';
      var regex = '';
      var regexSupporteNegatif = '';
      if (valeur !== '' && valeur != null) {
        if (supporteNegatif) {
          regexSupporteNegatif = '-?';
        }
        valeur = Scriba.nombre().texteVersNombre(valeur, langage);
        if (langage === 'fr') {
          valeur = valeur.replace(',', '.');
          regex = '^' + regexSupporteNegatif + '[0-9]+$';
          messageErreur = 'Veuillez saisir un nombre entier.';
        } else if (langage === 'en') {
          regex = '^' + regexSupporteNegatif + '[0-9]+,*';
          messageErreur = 'Please enter an integer.';
        }
        var reg = new RegExp(regex);
        if (!reg.test(valeur)) {
          message = messageErreur;
        }
      }
      return message;
    }
  }, {
    key: "controleNombreDecimal",
    value: function controleNombreDecimal(valeur, supporteNegatif, precision, langage) {
      langage = langage || 'fr';
      supporteNegatif = supporteNegatif || false;
      precision = precision || 2;
      var message = '';
      var messageErreur = '';
      var regex = '';
      var regexSupporteNegatif = '';
      if (valeur !== '' && valeur != null) {
        if (supporteNegatif) {
          regexSupporteNegatif = '-?';
        }
        valeur = Scriba.nombre().texteVersNombre(valeur, langage);
        if (langage === 'fr') {
          valeur = valeur.replace(',', '.');
          regex = '^' + regexSupporteNegatif + '[0-9]+(\.[0-9]{1,' + precision + '}){0,1}$';
          messageErreur = 'Veuillez saisir un nombre décimal (jusqu\'à ' + precision + ' décimales).';
        } else if (langage === 'en') {
          regex = '^' + regexSupporteNegatif + '[0-9]+,*(\.[0-9]{1,' + precision + '}){0,1}$';
          messageErreur = 'Please enter a number (until ' + precision + ' decimals).';
        }
        var reg = new RegExp(regex);
        if (!reg.test(valeur)) {
          message = messageErreur;
        }
      }
      return message;
    }
  }]);
  return Scriba_OfficeUITextFieldNombre;
}();
var Scriba_OfficeUITextFieldText = /*#__PURE__*/function () {
  function Scriba_OfficeUITextFieldText() {
    _classCallCheck(this, Scriba_OfficeUITextFieldText);
  }
  _createClass(Scriba_OfficeUITextFieldText, null, [{
    key: "controleEmail",
    value: function controleEmail(valeur, langage) {
      langage = langage || 'fr';
      var message = '';
      if (valeur !== '' && valeur != null) {
        var chaineRegex = '^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]{3,}\.[a-zA-Z0-9]{2,4}$';
        var reg = new RegExp(chaineRegex);
        if (!reg.test(valeur)) {
          message = langage === 'fr' ? 'Veuillez saisir une adresse mail valide.' : 'Please enter a valid email address.';
        }
      }
      return message;
    }
  }, {
    key: "controleTelephone",
    value: function controleTelephone(valeur, langage) {
      langage = langage || 'fr';
      var message = '';
      if (valeur !== '' && valeur != null) {
        var chaineRegex = '^[+]*[0-9]*$';
        var reg = new RegExp(chaineRegex);
        if (!reg.test(valeur)) {
          message = langage === 'fr' ? 'Veuillez saisir un numéro de téléphone valide.' : 'Please enter a valid phone number.';
        }
      }
      return message;
    }
  }, {
    key: "controleEmailObligatoire",
    value: function controleEmailObligatoire(valeur, langage) {
      langage = langage || 'fr';
      var message = '';
      if (valeur !== '' && valeur != null) {
        message = this.controleEmail(valeur, langage);
      } else {
        message = this.messageChampObligatoire(valeur, langage);
      }
      return message;
    }
  }, {
    key: "messageChampObligatoire",
    value: function messageChampObligatoire(valeur, langage) {
      langage = langage || 'fr';
      var message = "";
      if (valeur !== undefined) {
        if (valeur.length > 0) {
          message = '';
        } else {
          message = langage === 'fr' ? 'Ce champ est obligatoire.' : 'This field is required.';
        }
      } else {
        message = langage === 'fr' ? 'Ce champ est obligatoire.' : 'This field is required.';
      }
      return message;
    }
  }]);
  return Scriba_OfficeUITextFieldText;
}();
var Scriba_OfficeUIDatePicker = /*#__PURE__*/function () {
  function Scriba_OfficeUIDatePicker() {
    _classCallCheck(this, Scriba_OfficeUIDatePicker);
  }
  _createClass(Scriba_OfficeUIDatePicker, null, [{
    key: "DayPickerStrings",
    value: function DayPickerStrings(langage) {
      langage = langage || 'fr';
      return Scriba.traduction().stringsTermes()[langage].DayPickerStrings;
    }
  }]);
  return Scriba_OfficeUIDatePicker;
}();
var Scriba_OfficeUIComboBox = /*#__PURE__*/function () {
  function Scriba_OfficeUIComboBox() {
    _classCallCheck(this, Scriba_OfficeUIComboBox);
  }
  _createClass(Scriba_OfficeUIComboBox, null, [{
    key: "messageChampObligatoire",
    value: function messageChampObligatoire(cle, langage) {
      langage = langage || 'fr';
      var message = langage === 'fr' ? 'Ce champ est obligatoire.' : 'This field is required.';
      return cle > 0 && cle !== undefined ? '' : message;
    }
  }, {
    key: "messageChampObligatoireString",
    value: function messageChampObligatoireString(cle, langage) {
      langage = langage || 'fr';
      var message = langage === 'fr' ? 'Ce champ est obligatoire.' : 'This field is required.';
      return cle.length > 0 && cle !== undefined ? '' : message;
    }
  }, {
    key: "messageChampObligatoireAvecClefNulle",
    value: function messageChampObligatoireAvecClefNulle(cle, valeurClefNulle, langage) {
      langage = langage || 'fr';
      var message = langage === 'fr' ? 'Ce champ est obligatoire.' : 'This field is required.';
      return cle !== valeurClefNulle ? '' : message;
    }
  }]);
  return Scriba_OfficeUIComboBox;
}();
var Scriba_Chaine = /*#__PURE__*/function () {
  function Scriba_Chaine() {
    _classCallCheck(this, Scriba_Chaine);
  }
  _createClass(Scriba_Chaine, null, [{
    key: "nEstPasVide",
    value: function nEstPasVide(chaine) {
      //console.log('-----nEstPasVide :' + chaine);

      if (chaine !== undefined && chaine !== null) {
        //console.log('chaine !== undefined && chaine !== null');

        if (chaine.length > 0) {
          //console.log('nEstPasVide return true');
          //console.log('--------------------------');
          return true;
        }
      }

      //console.log('nEstPasVide return false');
      //console.log('--------------------------');
      return false;
    }
  }, {
    key: "getExtensionFichier",
    value: function getExtensionFichier(nomFichier) {
      return nomFichier.split('.').pop();
    }
  }]);
  return Scriba_Chaine;
}();
var Scriba_Fichier = /*#__PURE__*/function () {
  function Scriba_Fichier() {
    _classCallCheck(this, Scriba_Fichier);
  }
  _createClass(Scriba_Fichier, null, [{
    key: "EnregisterSous",
    value: function EnregisterSous(byteArray, NomDocument, typeMime) {
      typeMime = typeMime || "application/octet-stream";
      var blob = new Blob([byteArray], {
        type: typeMime
      });
      saveAs(blob, NomDocument);
    }
  }, {
    key: "ByteArrayVersBase64",
    value: function ByteArrayVersBase64(arrayBuffer) {
      var base64 = '';
      var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      var bytes = new Uint8Array(arrayBuffer);
      var byteLength = bytes.byteLength;
      var byteRemainder = byteLength % 3;
      var mainLength = byteLength - byteRemainder;
      var a, b, c, d;
      var chunk;

      // Main loop deals with bytes in chunks of 3
      for (var i = 0; i < mainLength; i = i + 3) {
        // Combine the three bytes into a single integer
        chunk = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];

        // Use bitmasks to extract 6-bit segments from the triplet
        a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
        b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
        c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
        d = chunk & 63; // 63       = 2^6 - 1

        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
      }

      // Deal with the remaining bytes and padding
      if (byteRemainder === 1) {
        chunk = bytes[mainLength];
        a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

        // Set the 4 least significant bits to zero
        b = (chunk & 3) << 4; // 3   = 2^2 - 1

        base64 += encodings[a] + encodings[b] + '==';
      } else if (byteRemainder === 2) {
        chunk = bytes[mainLength] << 8 | bytes[mainLength + 1];
        a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
        b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

        // Set the 2 least significant bits to zero
        c = (chunk & 15) << 2; // 15    = 2^4 - 1

        base64 += encodings[a] + encodings[b] + encodings[c] + '=';
      }
      return base64;
    }
  }, {
    key: "Base64VersByteArray",
    value: function Base64VersByteArray(ChaineBase64) {
      var byteCharacters = atob(ChaineBase64);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      return byteArray;
    }
  }]);
  return Scriba_Fichier;
}();
var Scriba_State = /*#__PURE__*/function () {
  function Scriba_State() {
    _classCallCheck(this, Scriba_State);
  }
  _createClass(Scriba_State, null, [{
    key: "setObjetPropriete",
    //met à jour une propriété d'un objet contenu dans le state
    value: function setObjetPropriete(_this, nomObjet, nomPropriete, valeur, callBack) {
      var objet = _objectSpread({}, _this.state[nomObjet]);
      objet[nomPropriete] = valeur;
      if (callBack != undefined) {
        _this.setState(_defineProperty({}, nomObjet, objet), callBack);
      } else _this.setState(_defineProperty({}, nomObjet, objet));
    } //met à jour des propriétés d'un objet contenu dans le state
  }, {
    key: "setObjetProprietes",
    value: function setObjetProprietes(_this, nomObjet, nomProprietes, callBack) {
      var objet = _objectSpread({}, _this.state[nomObjet]);
      for (var i = 0; i < nomProprietes.length; i++) {
        var nomPropriete = nomProprietes[i][0];
        var valeur = nomProprietes[i][1];
        objet[nomPropriete] = valeur;
      }
      if (callBack != undefined) _this.setState(_defineProperty({}, nomObjet, objet), callBack);else _this.setState(_defineProperty({}, nomObjet, objet));
    }
  }]);
  return Scriba_State;
}();
var Scriba_Outils = /*#__PURE__*/function () {
  function Scriba_Outils() {
    _classCallCheck(this, Scriba_Outils);
  }
  _createClass(Scriba_Outils, null, [{
    key: "getParameterByName",
    //********************************************************
    //obtient les queryStrings d'une URL 
    //name: nom du paramètre à récupérer
    //url:  url à scanner
    //********************************************************
    value: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }]);
  return Scriba_Outils;
}();